export default {
  prev: {
    default: 'Retour',
    toDashboard: 'Tableau de bord',
    offBoard: 'Refuser ce conseil',
  },
  next: {
    default: 'Continuer',
    sign: 'Signer le document',
    validateOperations: 'Valider mon opération',
    skip: 'Passer sans investir',
  },
  topic: 'Transmission',
  titles: {
    currentSituation: 'Votre situation actuelle',
    userSimulation: 'Votre scénario de transmission',
    leverSelection: "Vos leviers d'actions",
    coupleProtection: 'Améliorer la protection au sein du couple',
    barePropertyDonation: "Mesurer l'impact des donations en nue-propriété",
    exonerationDonation:
      "Mesurer l'impact des dons de sommes d'argent exonérés",
    lifeInsurance:
      "Comprendre l'intérêt de l'assurance-vie sur votre transmission",
    synthesisLongTerm: 'Anticipation de la transmission: récapitulatif',
    contractSelection: "Montant à allouer à votre projet d'investissement",
    financialInvestment:
      "Augmenter le poids de l'assurance-vie dans votre patrimoine",
    beneficiaryClause:
      "Modifier les clauses bénéficiaires de vos contrats d'assurance-vie",
    protection: 'Couvrir les coûts de la transmission avec la prévoyance',
    funeralCosts: "Financement des frais d'obsèques",
    synthesis: 'Synthèse des orientations retenues',
    report: "Rapport d'adéquation",
  },
  update: 'Appliquer les modifications',
  actionButtons: {
    cancel: 'Annuler',
    save: 'Enregistrer',
  },
}
